import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuItem } from '../../models/menu-item';

@Component({
  selector: 'app-menu-item-link',
  imports: [],
  templateUrl: './menu-item-link.component.html',
  styleUrls: ['./menu-item-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemLinkComponent {
  @Input({ required: true }) public item!: MenuItem;
}
